const lineOfBusinessTypes = {
  PHYSICAL: 'physical',
  DIGITAL: 'digital',
  HYBRID: 'hybrid',
} as const;

const lineOfBusinessTypeChoices = [
  {
    id: lineOfBusinessTypes.DIGITAL,
    name: 'Digital',
  },
  {
    id: lineOfBusinessTypes.HYBRID,
    name: 'Hybrid',
  },
  {
    id: lineOfBusinessTypes.PHYSICAL,
    name: 'Physical',
  },
];

export default lineOfBusinessTypeChoices;
